export const calctime = (value = 0) => {
  let totalSeconds = Math.ceil(value);
  let hours = Math.floor(totalSeconds / 3600);
  let minutes = Math.floor((totalSeconds - hours * 3600) / 60);
  let seconds = totalSeconds - hours * 3600 - minutes * 60;

  let timeString = '';
  if (hours > 0) {
    timeString += hours.toString().padStart(2, '0') + ':';
  }
  timeString += minutes.toString().padStart(2, '0') + ':';
  timeString += seconds.toString().padStart(2, '0');

  return timeString;
};

// 给一个时间戳，1715658427000，生成一个mmdd_mmss格式的时间(月日_时分)
export const formatTimestampToMDMS = (timestamp: number): string => {
  const date = new Date(timestamp);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${month}${day}_${hours}${minutes}`;
};

/**
 * 通过删除潜在的有害SQL关键字和特殊字符来清理给定的输入字符串。
 */
export const sanitizeString = (input: string) => {
  // 定义要匹配和删除的正则表达式
  const regex =
    /\b(and|exec|insert|select|drop|grant|alter|delete|update|count|chr|mid|master|truncate|char|declare|or)\b|[\*\;\+'\%]/gi;
  // 使用 replace 方法替换匹配到的内容为空字符串
  return input.replace(regex, '');
};

/**
 * 根据长/宽比例生成最大填充尺寸
 */
export const generateZiseFromRadio = (
  radio: number,
  maxSize: { width: number; height: number },
) => {
  let width, height;

  // 计算使用最大宽度还是最大高度
  if (maxSize.width / maxSize.height > radio) {
    // 如果容器的宽高比大于目标比例，使用高度进行限制
    height = maxSize.height;
    width = height * radio;
  } else {
    // 否则使用宽度进行限制
    width = maxSize.width;
    height = width / radio;
  }

  return {
    width,
    height,
  };
};
